// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"120f076a","247":"9a4736f9","378":"e5637786"}[chunkId] + ".chunk.js";
};